'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRouteId = exports.getRoute = exports.routingSelector = exports.routeParam = exports.routeParams = undefined;

var _get2 = require('lodash/fp/get');

var _get3 = _interopRequireDefault(_get2);

var _flow2 = require('lodash/fp/flow');

var _flow3 = _interopRequireDefault(_flow2);

var _partial2 = require('lodash/partial');

var _partial3 = _interopRequireDefault(_partial2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduxHistorySync = require('redux-history-sync');

var _reselect = require('reselect');

var _capeSelect = require('cape-select');

var _locationInfo = require('location-info');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routeParams = exports.routeParams = (0, _flow3.default)(_capeSelect.getProps, (0, _get3.default)('params'));
var routeParam = exports.routeParam = (0, _partial3.default)(_capeSelect.select, routeParams);

// We are using the redux-history-sync to put location into state.
function routeInfoSelector(routes, history) {
  if (!history) return history;
  return _extends({}, (0, _locationInfo.findRoute)(routes, history.location), { // params
    history: history
  });
}
// Pass in the state object and return some info about a "route".
// selectActiveKeyDefault() is a helper function to grab the current location info.
var routingSelector = exports.routingSelector = (0, _reselect.createSelector)(_locationInfo.selectRoutes, _reduxHistorySync.selectActiveKeyDefault, routeInfoSelector);
var getRoute = exports.getRoute = (0, _capeSelect.select)(routingSelector, 'route');
var getRouteId = exports.getRouteId = (0, _capeSelect.select)(getRoute, 'id');

exports.default = routingSelector;


//////////////////
// WEBPACK FOOTER
// ./~/cape-react-app/lib/routing.js
// module id = 698
// module chunks = 0